module.exports = __webpack_public_path__ + "about-renew-duo.jpg?9a7cd42ba6d2dbc68317d1b654b727f6";


//////////////////
// WEBPACK FOOTER
// ./src/images/about-renew-duo.jpg
// module id = 298
// module chunks = 0